import React from "react";
import { Link } from "react-router-dom";

const links = [
  {
    to: "/accounts/payment/Vouchers",
    label: "Payment Voucher",
    icon: "fa-solid fa-credit-card",
    gradient: "linear-gradient(to right, #FFAF7B, #D76D77)",
  },
  {
    to: "/accounts/payment/reciepts",
    label: "Receipt",
    icon: "fa-solid fa-file-invoice",
    gradient: "linear-gradient(to right, #4BC0C8, #C779D0)",
  },
  {
    to: "/accounts/journal",
    label: "Journal None Inventory",
    icon: "fa-solid fa-file-invoice",
    gradient: "linear-gradient(to right, #FFB75E, #ED8F03)",
  },
  {
    to: "/accounts/journal/inventory",
    label: "Inventory Journal",
    icon: "fa-solid fa-file-invoice",
    gradient: "linear-gradient(to right, #2C3E50, #4CA1AF)",
  },
  {
    to: "/accounts/contra",
    label: "Contra",
    icon: "fa-solid fa-file-invoice",
    gradient: "linear-gradient(to right, #485563, #29323C)",
  },
  {
    to: "/accounts/Invoices_works",
    label: "Invoices",
    icon: "fa-solid fa-book-atlas",
    gradient: "linear-gradient(to right, #FFD200, #182848)",
  },
  {
    to: "/accounts/budget_expenses",
    label: "Budget Expenses",
    icon: "fe fe-users",
    gradient: "linear-gradient(to right, #F37335,#182848)",
  },
  {
    to: "/accounts/project_budget_report",
    label: "Budget Expenses Report",
    icon: "fa-solid fa-file-invoice-dollar",
    gradient: "linear-gradient(to right, #355C7D, #6C5B7B)",
  },
  {
    to: "/accounts/trial_balance",
    label: "Trial Balance",
    icon: "fa-solid fa-scale-balanced",
    gradient: "linear-gradient(to right, #4e73df, #1cc88a)",
  },
  {
    to: "/accounts/balance_sheet",
    label: "Balance Sheet",
    icon: "fa-solid fa-group-arrows-rotate",
    gradient: "linear-gradient(to right, #8e44ad,#182848)",
  },
  {
    to: "/accounts/profit_losses_statement",
    label: "Profits & Loss Statement",
    icon: "fa-solid fa-magnifying-glass-chart",
    gradient: "linear-gradient(to right,#c39bd3,#182848)",
  },
  {
    to: "/accounts/transactions/list_all",
    label: "Transactions",
    icon: "fa-solid fa-up-right-and-down-left-from-center",
    gradient: "linear-gradient(to right, #3498db, #f1c40f)",
  },
  {
    to: "/accounts/ledger_types",
    label: "Ledger Types",
    icon: "fe fe-settings",
    gradient: "linear-gradient(to right, #B24592, #F15F79)",
  },
  {
    to: "/accounts/ledgers",
    label: "Ledgers",
    icon: "fa-solid fa-book",
    gradient: "linear-gradient(to right, #5DDFC4, #3FB06C)",
  },
  {
    to: "/accounts/cost_allocation_center",
    label: "Cost Allocation Center",
    icon: "fa-solid fa-sitemap",
    gradient: "linear-gradient(to right, #1B84FD, #2C3D88)",
  },
  {
    to: "/accounts/cost_allocation_center_expenditure",
    label: "Cost Allocation Center Expenditure",
    icon: "fa-brands fa-expeditedssl",
    gradient: "linear-gradient(to right, #1B84FD, #e0ad21e1)",
  },
  {
    to: "/accounts/manual_ledger_entry",
    label: "Manual Ledger Entry",
    icon: "fa-solid fa-bookmark",
    gradient: "linear-gradient(to right, #f20505, #46ef28b3)",
  },
];

const baseStyle = {
  borderRadius: "10px",
  fontSize: "14px",
  height: "35px",
  margin: "5px",
  color: "white",
};

function AccountingNav() {
  return (
    <div className="row mt-1 mb-1">
      {links.map((link, index) => (
        <Link
          key={index}
          to={link.to}
          className="btn ripple btn-outline-success btn-with-icon"
          style={{ ...baseStyle, background: link.gradient }}
        >
          <i className={link.icon}></i> &nbsp;
          <span className="sidemenu-label">{link.label}</span>
        </Link>
      ))}
    </div>
  );
}

export default AccountingNav;
